export default __webpack_public_path__ + "static/media/1255.4a7c110e.png";